import React from "react";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField } from "ui/Form";

import {
  CREATE_VERSION_MUTATION,
  READ_VERSIONS_QUERY_NAME,
} from "graphqlQueries/versions";

import { addVersionValidator } from "validators/addVersionValidator";

const initialValues = {
  version: "",
  description: "",
};

const fieldsWithPlaceForError = ["version", "description"];

const AddVersionDialog = (props) => {
  return (
    <DialogFormWithMutation
      mutationQueries={CREATE_VERSION_MUTATION}
      refetchQueries={[READ_VERSIONS_QUERY_NAME]}
      initialValues={initialValues}
      validationSchema={addVersionValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Add version"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Version information" />
      <FormTextField name="version" label="Version" />
      <FormTextField name="description" label="Description" />
    </DialogFormWithMutation>
  );
};

export default AddVersionDialog;
